import { hasRole } from '@/components/Atoms/Permissions'
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
} from '@/components/ui/navigation-menu'
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area'
import { useAuth } from '@/hooks/useAuth'
import { cn, InternalRoles } from '@/lib/utils'
import { buildPath } from '@/routes'
import { MccsRoles } from '@/@types/generated'
import { PropsWithChildren } from 'react'
import { NavLink as ReactRouterNavLink, To } from 'react-router'

interface InsurerNavigationProps {
  licenseNumber: number
}

const companiesRoles = [
  MccsRoles.INSURANCE_PROVIDER,
  MccsRoles.CREDENTIALING_ADMIN,
  MccsRoles.CHIEF_INVESTIGATOR,
]

export default function InsurerNavigation({
  licenseNumber,
}: InsurerNavigationProps) {
  const { user } = useAuth()

  return (
    <div className="bg-primary text-primary-foreground rounded-md p-4">
      <ScrollArea className="-mb-2 w-full pb-1 whitespace-nowrap">
        <NavigationMenu>
          <NavigationMenuList className="flex gap-4 lg:gap-6">
            {hasRole(InternalRoles, user) && (
              <InsurerNavigation.Item
                to={buildPath('/insurance/insurers/:licenseNumber/users', {
                  licenseNumber: String(licenseNumber),
                })}
              >
                Users
              </InsurerNavigation.Item>
            )}
            {hasRole(companiesRoles, user) && (
              <InsurerNavigation.Item
                to={buildPath('/insurance/insurers/:licenseNumber/companies', {
                  licenseNumber: String(licenseNumber),
                })}
              >
                Companies
              </InsurerNavigation.Item>
            )}
          </NavigationMenuList>
        </NavigationMenu>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  )
}

InsurerNavigation.Item = function InsurerNavigationItem({
  to,
  children,
}: PropsWithChildren<{ to: To }>) {
  return (
    <NavigationMenuItem className="pb-1">
      <ReactRouterNavLink
        to={to}
        className={({ isActive }) =>
          cn(
            'hover:decoration-primary-foreground whitespace-nowrap underline decoration-transparent decoration-2 underline-offset-6 transition-colors duration-200',
            isActive ? 'decoration-primary-foreground' : null
          )
        }
      >
        {children}
      </ReactRouterNavLink>
    </NavigationMenuItem>
  )
}
